import { UserType } from '@avanta/shared/constants/users';

export { type AuthInfo } from '@avanta/shared/types/auth';

export const AcceptedUsers = [UserType.ENTERPRISE, UserType.ADMIN_ENTERPRISE] as const;
